import { isWithinAppDateWindow, parseAppDateTime } from "../../utils";

function getStatusFromWindow({ start_at, end_at }) {
    const now = Date.now();
    const start = parseAppDateTime(start_at);
    const end = parseAppDateTime(end_at);

    if (!Number.isFinite(start) || !Number.isFinite(end)) {
        return { key: "finished", label: "Finished", severity: "secondary" };
    }

    if (now < start) {
        return { key: "upcoming", label: "Upcoming", severity: "info" };
    }

    if (isWithinAppDateWindow({ start_at, end_at, now })) {
        return { key: "ongoing", label: "Ongoing", severity: "success" };
    }

    return { key: "finished", label: "Finished", severity: "secondary" };
}

export function getExamSeriesStatus({ start_at, end_at }) {
    return getStatusFromWindow({ start_at, end_at });
}

export function getExamStatus({ start_at, end_at }) {
    return getStatusFromWindow({ start_at, end_at });
}

export function getSecondsUntil({ date }) {
    if (!date) return 0;
    const target = parseAppDateTime(date);
    if (!Number.isFinite(target)) return 0;
    return Math.max(0, Math.floor((target - Date.now()) / 1000));
}

export const SECONDS_IN_24_HOURS = 24 * 60 * 60;

export function shouldShowCountdownUntilStart(secondsUntilStart) {
    return secondsUntilStart > 0 && secondsUntilStart < SECONDS_IN_24_HOURS;
}
